import React from 'react'
import { Drawer } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { withStyles } from "@material-ui/core/styles";
import {
    ANCHOR_PORTAL_HEADER_LINKS
} from '../../constants/internalHeaderLinks';

import { doLogout } from '../../utils/auth';

const topOffset = '40px';
const styles = {
  modal: {
    top: topOffset,
    background: 'none'
  },
  root: {
    zIndex: '1300'
  },
  paper: {
    top: 0,
    background: 'rgba(0, 0, 0, 0.9)',
    width: '350px'
  }
}

class AnchorDrawerNavigation extends React.Component {

    buttonClickAction = link => {
      if (link.title === 'Sign Out') {
        doLogout();
      }
    }

    render() {
      const { open, onClose, anchor, classes } = this.props;

      return (
          <Drawer
            classes={classes}
            open={open}
            onClose={onClose}
            anchor={anchor}
            variant='persistent'
          >
            <div className="mobdraw-content">
              <div className="mobdraw-header">
                <div className="drawer-close-wrapper">
                  <Close
                    onClick={this.props.onClose}
                    classes={{
                      root: {
                        height: '40px'
                      }
                    }}
                  />
                </div>
              </div>

              <div className="mobdraw-menu-section">
                <ul className='nav anchor-drawer-navigation-nav'>
                  {
                    ANCHOR_PORTAL_HEADER_LINKS.map(link => {
                      const content = (
                        <>
                          {link.icon ? <img className="anchor-portal-nav-icon" src={link.icon} /> : ''}
                          {link.title}
                        </>
                      );
                      return (
                        <li key={link.id} className="mobdraw-menu-section__item">
                          {link.button ? (
                            <button onClick={() => this.buttonClickAction(link)}>
                              {content}
                            </button>
                          ) : (
                            <a
                              href={link.href}
                              className={window.location.pathname === link.href ? "active" : null}
                            >
                              {content}
                            </a>
                          )}
                        </li>
                      )
                    })
                  }
                </ul>
              </div>
            </div>
          </Drawer>
      );
    }
}
export default withStyles(styles)(AnchorDrawerNavigation);
